module.exports = __webpack_public_path__ + "img/wind1.7b50a4c6.png";